export default class EventWrapper {
	private action;
	private context;

	constructor(action, context) {
		this.action = action;
		this.context = context;
	}
}
